<template>
    <div class="modal-out">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">{{headerName}}</div>
                <button type="button" class="btn-close" @click="closeSelf">X</button>
            </div>
            <div class="modal-body">
                <el-form :model="addForm" :rules="rules" ref="addForm">
                    <div>
                        <el-row>
                            <el-col :span="item.span" class="item" v-for="(item,i) in formData" :key="i">
                                <el-form-item :label="item.name" :prop="item.value">
                                    <el-input v-model="addForm[item.value]" :placeholder="'请输入'+item.name"  v-if="item.type=='input'"></el-input>
                                    <el-input v-model.number="addForm[item.value]" :placeholder="'请输入'+item.name" type="number" v-if="item.type=='number'"></el-input>
                                    <el-input v-model="addForm[item.value]" type="textarea" rows="2" :placeholder="'请输入'+item.name" v-if="item.type=='textarea'"></el-input>
                                    <el-date-picker
                                        v-model="addForm[item.value]"
                                        type="date"
                                        value-format="yyyy-MM-dd"
                                        :placeholder="'请选择'+item.name"
                                        v-if="item.type=='date'"
                                        style="width:100%">
                                    </el-date-picker>
                                    <el-select v-model="addForm[item.value]" :placeholder="'请选择'+item.name" v-if="item.type=='select'" style="width:100%">
                                        <el-option
                                            v-for="itemSelect in item.options"
                                            :key="itemSelect.value"
                                            :label="itemSelect.label"
                                            :value="itemSelect.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                </el-form>
            </div>
            <div class="modal-footer">
                <el-button :loading="loading" type="primary" @click="confirm('addForm')">{{bottomName}}</el-button>
            </div>
        </div>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";


    export default {
        name: 'Add',
        data() {
            return {
                loading: false,
                formData:[],
                headerName:"",
                bottomName:'',
                type:'',
                url:"EHealthRecord/Add",
                addForm:{
                    timeStr:timeStr,
                    sign:'',
                    staffCode:getStaffCode(),
                    ehealthRecordCode:'',
                    confirmedTime:'',
                    elderlyCode:'',
                    remarks:'',
                    hospital:'',
                    name:'',
                    illnessStatus:'',
                    bloodTraVol:'',
                    reasonInfusion:'',
                    status:'',
                    relation:'',
                },
                rules:{
                    name:[
                        { required: true, message: '请输入名称', trigger: 'blur' },
                    ],
                    remarks:[
                        { required: true, message: '请输入备注', trigger: 'blur' },
                    ],
                    hospital:[
                        { required: true, message: '请输入医院', trigger: 'blur' },
                    ],
                    illnessStatus:[
                        { required: true, message: '请填写状态', trigger: 'blur' },
                    ],
                    confirmedTime:[
                        { required: true, message: '请选择时间', trigger: 'blur' },
                    ],
                    bloodTraVol:[
                        { required: true, message: '请输入输血量', trigger: 'blur' },
                    ],
                    reasonInfusion:[
                        { required: true, message: '请输入输血原因', trigger: 'blur' },
                    ],
                    relation:[
                        { required: true, message: '请选择关系', trigger: 'blur' },
                    ]
                },
            }
        },

        methods: {
            init(formDatas,data,datas){
                var dataObj=datas?datas:data
                this.bottomName=datas?'编辑':'添加'
                this.url=datas?'EHealthRecord/Edit':'EHealthRecord/Add'
                for(var i in this.addForm){
                    if(i!='timeStr'&& i!='staffCode'){
                        dataObj[i]?this.addForm[i]=dataObj[i]:this.addForm[i]=''
                        if(i=='confirmedTime')this.addForm[i]=this.addForm[i].slice(0,10)
                    }
                }
                this.type=data.type
                this.formData=[]
                this.formData=formDatas
            },
            closeSelf() {
                this.$refs.addForm.resetFields()
                this.$emit("closeHealthRecordAdd");
            },

            confirm(addForm){
                this.$refs[addForm].validate((valid) => {
                    if(valid){
                        this.addSubmit();
                    }else {
                        console.log('error submit!!');
                        return false;
                    }
                })

            },
            addSubmit(){
                if(this.loading){
                    return;
                }else{
                    this.loading = true;
                }
                this.addForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);

                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+this.url,
                    data: this.addForm
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.$refs.addForm.resetFields()
                            this.$emit("closeHealthRecordAdd");
                            this.$emit("getListHealth",this.type);
                        }else if(response.data.error == 1){
                            this.$message.error(response.data.message)
                        }
                    }
                )
            },


        }
    }


</script>



<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 20px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
  }
  .avatar {
    width: 100px;
    height: 100px;
    display: block;
    border-radius: 5px;
  }
</style>

<style lang="scss" scoped>

    .modal-goodslist {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0,0,0,.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99;

        .modal {
            background-color: #fff;
            box-shadow:  0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
            overflow-x:auto;
            display: flex;
            flex-direction: column;
            border-radius: 10px;
            width: 600px;

            .modal-header {
                border-bottom: 1px solid #eee;
                color: #313131;
                justify-content: space-between;
                padding: 10px;
                display: flex;
            }
            .modal-body /deep/ .el-upload--picture-card{
                width: 100px;
                height: 100px;
                line-height: 100px;
            }
            .modal-body {
                position: relative;
                padding: 20px 0px;
                z-index: 99;
                height: 100%;
            }
            .modal-footer {
                border-top: 1px solid #eee;
                justify-content: flex-end;
                padding: 15px;
                display: flex;
            }
            .uploadButton{
                border-top: 1px solid #eee;
                padding: 10px 0 0;
                display: flex;
                 .el-button{
                    width: 100px;
                }
            }


        }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }


</style>
